<!-- Full Width Container -->
<div class="py-8">

	<!-- Centered Content Box -->
	<div class="pixel-9-slice">
		<div class="max-w-4xl mx-auto bg-base-100 p-8 min-h-[600px] sm:pb-[0px] pb-[170px]">
			<!-- Reset Password Header -->
			<h2>Reset Password</h2>
			<p class="text-base-content/60 text-xs mt-2 mb-8">Enter your email address and we'll send you a link to reset your password.</p>

			<!-- Error Message -->
			@if (errorMessage()) {
				<div class="bg-error/10 border border-error text-error p-3 rounded mb-4">
					{{ errorMessage() }}
				</div>
			}

			<!-- Success Message -->
			@if (successMessage()) {
				<div class="bg-success/10 border border-success text-success p-3 rounded mb-4">
					{{ successMessage() }}
				</div>
			}

			<!-- Forgot Password Form -->
			<form (ngSubmit)="onSubmit()" #forgotPasswordForm="ngForm">
				<!-- Email Field -->
				<div class="mb-6">
					<label for="email" class="block mb-1.5 text-base-content font-medium">Email Address</label>
					<input
						type="email"
						id="email"
						name="email"
						[(ngModel)]="email"
						required
						class="w-full p-3 border-2 rounded"
						[class.border-error]="forgotPasswordForm.form.get('email')?.invalid && forgotPasswordForm.form.get('email')?.touched"
						[class.border-base-300]="!(forgotPasswordForm.form.get('email')?.invalid && forgotPasswordForm.form.get('email')?.touched)"
						placeholder="Enter email"
						(blur)="forgotPasswordForm.form.get('email')?.markAsTouched()"
					>
				</div>

			<!-- Submit Button -->
			<button
				type="submit"
				[disabled]="isLoading() || forgotPasswordForm.form.invalid"
				class="red-cta-btn-xlg retro-pixel-regular"
			>
				@if (isLoading()) {
					<span>SENDING</span>
				} @else {
					<span>SEND LINK</span>
				}
			</button>
			</form>

			<hr class="border-t-4 border-gray-300 my-8">

			<!-- Links -->
			<div class="flex flex-col gap-2 mb-4">
				<p class="text-base-content/60 m-0 mb-2.5 text-sm">
					Remember your password?
					<button
						type="button"
						(click)="goToLogin()"
						class="bg-transparent border-none text-primary cursor-pointer "
					>Sign in
					</button>
				</p>
				<p class="text-base-content/60 m-0 text-sm">
					No account?
					<button
						type="button"
						(click)="goToSignup()"
						class="bg-transparent border-none text-primary cursor-pointer "
					>Sign up
					</button>
				</p>
			</div>

		</div>
	</div>

	<!-- Overlaid Crustopher -->
	<div class="crustopher-overlay">
		<img [src]="avatarImage()" alt="Crustopher Avatar" class="crustopher-image" (click)="onAvatarClick()">
	</div>

</div>
